// React and related imports
import React from 'react';

// Unauthorized Error Svg
import Unauthorized401 from '../assets/images/401-error-unauthorized-animate.svg';

// i18n hooks
import { useTranslation } from 'react-i18next';

// Hooks
import { usePageTitle } from '../hooks/usePageTitle';

export const UnauthorizedPage: React.FC = () => {
  const { t } = useTranslation();

  usePageTitle(t('pageTitles.unauthorized'));

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <h1 className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-red-500 md:text-4xl lg:text-5xl">
        You are not authorized to access this website.
      </h1>
      <p className="mb-6 text-lg font-normal text-gray-200 sm:px-16 lg:text-xl xl:px-48">
        Please contact your administrator for assistance.
      </p>
      <img
        src={Unauthorized401}
        alt="Unauthorized Error"
        className="h-auto w-full max-w-lg"
      />
    </div>
  );
};
